import { Box, Button, Typography } from '@mui/material'

import acreConfig from '@acre/config'

type Props = { isDisabled: boolean }

const AuthErrorPage = ({ isDisabled }: Props) => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    minHeight="100vh"
    gap={3}
    p={4}
    textAlign="center"
  >
    <Typography variant="h5">
      {isDisabled ? 'Account disabled' : 'Sign in error'}
    </Typography>
    <Typography variant="body1" maxWidth={480}>
      {isDisabled
        ? 'Your account has been disabled. Please contact your principal.'
        : 'Please sign out and sign in again. If you continue to experience issues, contact Acre support.'}
    </Typography>
    <Button variant="primary" href={acreConfig.LOGOUT_URL}>
      Sign out
    </Button>
  </Box>
)

export default AuthErrorPage
